import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7570ab44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center-dropdown-table-container" }
const _hoisted_2 = {
  class: "center-dropdown-table",
  style: {"margin-top":"0px"}
}
const _hoisted_3 = { style: {"width":"14.2857%"} }
const _hoisted_4 = { class: "center-buttons bottom-margin-only" }
const _hoisted_5 = ["disabled", "title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Summary ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":".7rem"} }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { style: {"width":"14.2857%"} }
const _hoisted_10 = { class: "center-buttons bottom-margin-only" }
const _hoisted_11 = ["disabled", "title"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Box 1 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":".7rem"} }, " (Sales VAT) ", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { style: {"width":"14.2857%"} }
const _hoisted_16 = { class: "center-buttons bottom-margin-only" }
const _hoisted_17 = ["disabled", "title"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Box 3 ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.7rem"} }, " (Total VAT Due) ", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { style: {"width":"14.2857%"} }
const _hoisted_22 = { class: "center-buttons bottom-margin-only" }
const _hoisted_23 = ["disabled", "title"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Box 4 ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.7rem"} }, " (Reclaimed VAT) ", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { style: {"width":"14.2857%"} }
const _hoisted_28 = { class: "center-buttons bottom-margin-only" }
const _hoisted_29 = ["disabled", "title"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Box 5 ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.7rem"} }, " (Paid or Reclaimed VAT) ", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { style: {"width":"14.2857%"} }
const _hoisted_34 = { class: "center-buttons bottom-margin-only" }
const _hoisted_35 = ["disabled", "title"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Box 6 ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.7rem"} }, " (Sales Net Value) ", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { style: {"width":"14.2857%"} }
const _hoisted_40 = { class: "center-buttons bottom-margin-only" }
const _hoisted_41 = ["disabled", "title"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Box 7 ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"0.7rem"} }, " (Purchases Net Value) ", -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]

import { watch } from "vue"
import {
    tabs,
    currentTab,
    journalTypeSelection,
} from "@/services/helpers/VATReturns/VATReturnsVariables";
import {
    ToggleTab,
} from "@/services/helpers/VATReturns/VATReturnsFunctions";
import {
    GetTabData,
} from "@/services/helpers/VATReturns/VATReturnsFunctions";
// Misc
import log from "loglevel";


export default /*#__PURE__*/_defineComponent({
  __name: 'VATReturnsTabs',
  setup(__props) {

watch(
    () => currentTab.value,
    () => {
        const name = "watch(currentTab)";
        log.debug(name);

        journalTypeSelection.value = "";
        GetTabData();
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: _normalizeClass(`tab-button-left ${_unref(currentTab) == _unref(tabs).Summary ? 'selected' : 'unselected'}`),
                style: {"width":"100%"},
                disabled: _unref(currentTab) == _unref(tabs).Summary,
                title: _unref(currentTab) == _unref(tabs).Summary ? 'Currently viewing Summary' : 'Click to view Summary',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(ToggleTab)(_unref(tabs).Summary)))
              }, _hoisted_8, 10, _hoisted_5)
            ])
          ]),
          _createElementVNode("td", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: _normalizeClass(`tab-button-middle ${_unref(currentTab) == _unref(tabs).Box1 ? 'selected' : 'unselected'}`),
                style: {"width":"100%"},
                disabled: _unref(currentTab) == _unref(tabs).Box1,
                title: _unref(currentTab) == _unref(tabs).Box1 ? 'Currently viewing Box 1' : 'Click to view Box 1',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(ToggleTab)(_unref(tabs).Box1)))
              }, _hoisted_14, 10, _hoisted_11)
            ])
          ]),
          _createElementVNode("td", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: _normalizeClass(`tab-button-middle ${_unref(currentTab) == _unref(tabs).Box3 ? 'selected' : 'unselected'}`),
                style: {"width":"100%"},
                disabled: _unref(currentTab) == _unref(tabs).Box3,
                title: _unref(currentTab) == _unref(tabs).Box3 ? 'Currently viewing Box 3' : 'Click to view Box 3',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(ToggleTab)(_unref(tabs).Box3)))
              }, _hoisted_20, 10, _hoisted_17)
            ])
          ]),
          _createElementVNode("td", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                class: _normalizeClass(`tab-button-middle ${_unref(currentTab) == _unref(tabs).Box4 ? 'selected' : 'unselected'}`),
                style: {"width":"100%"},
                disabled: _unref(currentTab) == _unref(tabs).Box4,
                title: _unref(currentTab) == _unref(tabs).Box4 ? 'Currently viewing Box 4' : 'Click to view Box 4',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(ToggleTab)(_unref(tabs).Box4)))
              }, _hoisted_26, 10, _hoisted_23)
            ])
          ]),
          _createElementVNode("td", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                class: _normalizeClass(`tab-button-middle ${_unref(currentTab) == _unref(tabs).Box5 ? 'selected' : 'unselected'}`),
                style: {"width":"100%"},
                disabled: _unref(currentTab) == _unref(tabs).Box5,
                title: _unref(currentTab) == _unref(tabs).Box5 ? 'Currently viewing Box 5' : 'Click to view Box 5',
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(ToggleTab)(_unref(tabs).Box5)))
              }, _hoisted_32, 10, _hoisted_29)
            ])
          ]),
          _createElementVNode("td", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                class: _normalizeClass(`tab-button-middle ${_unref(currentTab) == _unref(tabs).Box6 ? 'selected' : 'unselected'}`),
                style: {"width":"100%"},
                disabled: _unref(currentTab) == _unref(tabs).Box6,
                title: _unref(currentTab) == _unref(tabs).Box6 ? 'Currently viewing Box 6' : 'Click to view Box 6',
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(ToggleTab)(_unref(tabs).Box6)))
              }, _hoisted_38, 10, _hoisted_35)
            ])
          ]),
          _createElementVNode("td", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                class: _normalizeClass(`tab-button-right ${_unref(currentTab) == _unref(tabs).Box7 ? 'selected' : 'unselected'}`),
                style: {"width":"100%"},
                disabled: _unref(currentTab) == _unref(tabs).Box7,
                title: _unref(currentTab) == _unref(tabs).Box7 ? 'Currently viewing Box 7' : 'Click to view Box 7',
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(ToggleTab)(_unref(tabs).Box7)))
              }, _hoisted_44, 10, _hoisted_41)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})